import { isObject } from '../is-object';

type Transformer = (key: string) => string;
type Value = string | number | boolean | symbol | null | undefined | Record<string | symbol, any> | Value[];

export function deepTransformKeys(obj: Value, transformer: Transformer): any {
  const isArray = Array.isArray(obj);

  if (!isObject(obj) && !isArray) return obj;
  if (isArray) return obj.map((value) => deepTransformKeys(value as Value, transformer));

  const keys = Object.keys(obj as Record<string | symbol, unknown>);
  const newObj: Record<string, unknown> = {};

  // Using for loop for performance
  for (const key of keys) {
    const keyValue: Value = obj[key];
    const shouldTransform = isObject(keyValue) || Array.isArray(keyValue);

    newObj[transformer(key)] = shouldTransform ? deepTransformKeys(keyValue, transformer) : keyValue;
  }

  return newObj;
}
